import React from 'react';
import styles from './CommonPage.module.css';

const DashboardPage: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>대시보드</h1>
        <p>One Support 관리자 페이지에 오신 것을 환영합니다.</p>
      </div>
      
      <div className={styles.grid}>
        <div className={styles.card}>
            <h3>시스템 상태</h3>
            <p>정상 작동 중</p>
        </div>
        {/* Placeholder for future stats */}
      </div>
    </div>
  );
};

export default DashboardPage;
